import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../context/LanguageContext';

const seoDefaults = {
  es: {
    title: 'Páginas web en 48 horas por $25.000 | Synapsis Team',
    description: 'Landing, portfolio o web de empresa: todas al mismo precio, listas en 48 horas. Sistemas web a medida en 7 días. No pagás hasta verla terminada.',
  },
  en: {
    title: 'Websites live in 48 hours for $499 | Synapsis Team',
    description: 'Landing page, portfolio or company site — same price for all of them, live in 48 hours. Custom web systems in 7 days. You do not pay until you see it working.',
  },
};

const SEO = ({
  title,
  description,
  url = 'https://www.synapsis.team',
  image = 'https://www.synapsis.team/og-image.png',
  imageAlt = 'Synapsis Team',
  structuredData = null,
  children
}) => {
  const { language } = useLanguage();
  const localeMap = { es: 'es_ES', en: 'en_US' };
  const locale = localeMap[language] || 'es_ES';

  const defaults = seoDefaults[language] || seoDefaults.es;
  const finalTitle = title || defaults.title;
  const finalDescription = description || defaults.description;

  return (
    <Helmet htmlAttributes={{ lang: language || 'es' }}>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <link rel="canonical" href={url} />
      {/* No hreflang: the language switch is client-side only, all routes
          share one URL per page, so there's no separate localized URL to
          point hreflang at. See public/index.html for the full rationale. */}
      {/* Open Graph */}
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={imageAlt} />
      <meta property="og:locale" content={locale} />
      <meta property="og:site_name" content="Synapsis Team" />
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={imageAlt} />
      {/* Theme */}
      <meta name="theme-color" content="#08090C" />
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
      {children}
    </Helmet>
  );
};

export default SEO;
